import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor() { }
  toasts: Toast[] = [];
  

  showSuccess(message:string){
    this.show({ content:message, classname: 'sucess-aleart text-light', delay: 10000 })
  }

  showError(message:string){
    this.show({ content:message, classname: 'bg-danger text-light', delay: 10000 })
  }

  private show(toast: Toast) {
		this.toasts.push(toast);
    console.log("myToasyArray",this.toasts)
	}

  

	remove(toast: Toast) {
		this.toasts = this.toasts.filter((t) => t !== toast);
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
	}
}
export interface Toast {
	// template: TemplateRef<any>;
  content:string;
	classname?: string;
	delay?: number;
}